export default {
  install(app) {
    app.config.globalProperties.$intercom = {
      async boot(user) {
        const appId = import.meta.env.VITE_INTERCOM_APP_ID;
        await loadIntercomScript(appId);

        window.intercomSettings = { app_id: appId, ...user };
        window.Intercom("boot", window.intercomSettings);
      },
      update(user) {
        if (window.Intercom) {
          window.Intercom("update", user);
        }
      },
      shutdown() {
        if (window.Intercom) {
          window.Intercom("shutdown");
        }
      },
      show() {
        if (window.Intercom) {
          window.Intercom("show");
        }
      },
      hide() {
        if (window.Intercom) {
          window.Intercom("hide");
        }
      }
    };

    function loadIntercomScript(appId) {
      return new Promise((resolve, reject) => {
        if (window.Intercom && typeof window.Intercom === "function") return resolve();

        const script = document.createElement("script");
        script.src = `https://widget.intercom.io/widget/${appId}`;
        script.async = true;
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      });
    }
  }
};
